module.exports = __webpack_public_path__ + "static/media/gallery-addBlue.967cebea.svg";